import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Icon,
    TablePagination,
    Grid,
    Avatar,
    Checkbox,
    TableSortLabel,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    useMediaQuery,
    FormControl,
    InputLabel,
    Input,
    InputAdornment,
    InputBase,
    FormControlLabel,
    TextField,
    Select,
    MenuItem,
} from '@mui/material'
import React from 'react'
import { Box, styled } from '@mui/system'
import { MatxSearchBox } from 'app/components'
import { visuallyHidden } from '@mui/utils'
import { useTheme } from '@emotion/react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import SearchFilter from './SearchFilter'
import ImportMeasurementMenu from './ImportMeasurementMenu'
import axios from 'axios'
import { useEffect } from 'react'

const StyledSearch = styled(MatxSearchBox)(({ themed }) => ({
    width: '100px',
}))

const StyledIcon = styled(Icon)(({ theme }) => ({
    fontSize: '0.5rem',
    marginRight: '5px',
}))

const StyledTable = styled(Table)(({ theme }) => ({
    whiteSpace: 'pre',
    '& thead': {
        '& tr': {
            '& th': {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    },
    '& tbody': {
        '& tr': {
            '& td': {
                paddingLeft: 0,
                textTransform: 'capitalize',
            },
        },
    },
}))

const headCells = [
    {
        id: 'workpermit_id',
        numeric: false,
        label: 'เลขประจำตัว',
        icon: null,
        sortable: true,
    },
    {
        id: 'worker_name',
        numeric: false,
        label: 'ชื่อ-นามสกุล',
        icon: null,
        sortable: true,
        hidexs: true,
    },
    {
        id: 'job_name',
        numeric: false,
        label: 'ตำแหน่งงาน',
        icon: null,
        sortable: true,
        hidexs:true
    },
    {
        id: 'location_name',
        numeric: false,
        label: 'สถานที่ปฏิบัติงาน',
        icon: null,
        sortable: true,
        hidexs:true
    },
    {
        id: 'company_name',
        numeric: false,
        label: 'บริษัท',
        icon: null,
        sortable: true,
        hidexs: true,
    },
    {
        id: 'evaluation_flag',
        numeric: false,
        label: 'ผลการประเมิน',
        icon: null,
        sortable: true,
    },
]
const HIDE_XS = { xs: 'none', sm: 'table-cell' }
const options = ['Active/Inactive']

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) {
            return order
        }
        return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
}

const EnhancedTableHead = ({ order, orderBy, onRequestSort, headCells }) => {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    const renderCell = (item) => {
        if (item.sortable) {
            return (
                <TableCell
                    key={item.id}
                    align={item.numeric ? 'right' : 'left'}
                    sortDirection={orderBy === item.id ? order : false}
                    sx={{display:item.hidexs?HIDE_XS:'table-cell'}}
                    
                >
                    <TableSortLabel
                        active={orderBy === item.id}
                        direction={orderBy === item.id ? order : 'asc'}
                        onClick={createSortHandler(item.id)}
                    >
                        {item.icon ? (
                            <StyledIcon fontSize={'small'}>
                                {item.icon}
                            </StyledIcon>
                        ) : null}
                        {item.label}
                        {orderBy === item.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc'
                                    ? 'sorted descending'
                                    : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
            )
        } else {
            return (
                <TableCell
                    key={item.id}
                    align={item.numeric ? 'right' : 'left'}
                    sx={
                        item.hidexs
                            ? {
                                  visibility: { xs: 'hidden', md: 'visible' },
                                  width: { xs: '0', md: 'auto' },
                              }
                            : { visibility: 'visible' }
                    }
                >
                    {item.icon ? <StyledIcon>{item.icon}</StyledIcon> : null}
                    {item.label}
                </TableCell>
            )
        }
    }

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => renderCell(headCell))}
            </TableRow>
        </TableHead>
    )
}
const createFilter = (date, shift) => {
    return {
        shift: shift + 1,
        shift_date: date.toISOString().split('T')[0],
    }
}

const Small = styled('small')(({ bgcolor }) => ({
    height: 15,
    width: 50,
    color: '#fff',
    padding: '2px 8px',
    borderRadius: '4px',
    overflow: 'hidden',
    background: bgcolor,
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
    margin: '2px',
}))

const TableData = styled(Typography)(() => ({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
}))

const AttendanceTable = ({
    measurments,
    pageSize,
    total,
    totalPages,
    items,
    currentPage,
    locations,
    companies,
    foremen,
    workjobs,
    onFilterApply,
    onPageChange,
    onRowsPerPageChange,
    onSortedChanged,
    onUserSelected,
    onDownloadTemplate,
    onUploadMeasurement
}) => {

    
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('name')
    const [importMeasurmentOpen, setImportMeasurmentOpen] = React.useState(false)
    const [data, setData] = React.useState([])

    const importMeasurmentClose = (uploadFile, shift, date) => {
        onUploadMeasurement(uploadFile, shift, date)
        setImportMeasurmentOpen(false)
    }

    const importMeasurmentShow = () =>{
        setImportMeasurmentOpen(true)
    }
    const { palette } = useTheme()
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
    const bgError = palette.error.main
    const bgNormal = '#16C35B'
    const [selectedUser, setSelectedUser] = React.useState()
    const [
        selectedUserMeasurements,
        setSelectedUserMeasurements,
    ] = React.useState()
    const [dialogOpen, setDialogOpen] = React.useState(false)

    const handleChangePage = (event, newPage) => {
        if (onPageChange) onPageChange(newPage)
        console.log(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        if (onRowsPerPageChange){
            setData([])
            onRowsPerPageChange(event.target.value)
        }
        console.log(event.target.value)
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
        onSortedChanged(property, isAsc ? 'desc' : 'asc')
    }

    const handleClick = (event, name) => {}

    const handleDialogClose = () => {
        setDialogOpen(false)
    }

    useEffect(()=>{
        if(measurments){
            console.log("L"+measurments.length)
        }
        setData(measurments);
    }, [measurments])

    useEffect(()=>{
        if(data){
            console.log("DL "+data.length)
        }
    }, [data])

    

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        currentPage > 0 ? Math.max(0, (1 + currentPage) * pageSize - total) : 0

    return (
        <Box width="100%" overflow="auto">
            <Box>
                <SearchFilter
                    locations={locations}
                    companies={companies}
                    workjobs={workjobs}
                    foremen={foremen}
                    onFilterApply={onFilterApply}
                />
            </Box>
            <Grid
                container
                gap={2}
                display="flex"
                sx={{ justifyContent: 'flex-end' }}
            >
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<Icon>download</Icon>}
                    onClick={onDownloadTemplate}
                >
                    เรียกไฟล์ต้นแบบ
                </Button>
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<Icon>file_upload</Icon>}
                    onClick={importMeasurmentShow}
                >
                    นำเข้าข้อมูล
                </Button>
                <ImportMeasurementMenu
                                    open={importMeasurmentOpen}
                                    handleClose={importMeasurmentClose}
                                />
            </Grid>
            <StyledTable>
                <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={total}
                    headCells={headCells}
                />

                <TableBody>
                    { data.map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`

                        return (
                            <TableRow
                                hover
                                onClick={(event) =>
                                    handleClick(event, row.name)
                                }
                                role="checkbox"
                                tabIndex={-1}
                                key={row.index}
                            >
                                <TableCell
                                    component="th"
                                    id={labelId}
                                    scope="row"
                                    padding="none"
                                >
                                    <TableData>{row.cid}</TableData>
                                </TableCell>
                                <TableCell
                                    align="left"
                                    sx={{
                                        visibility: {
                                            xs: 'hidden',
                                            md: 'visible',
                                        },
                                        display:HIDE_XS
                                    }}
                                >
                                    <TableData>{row.name}</TableData>
                                </TableCell>
                                <TableCell align="left" sx={{display:HIDE_XS}}>
                                    <TableData>{row.work_title}</TableData>
                                </TableCell>
                                <TableCell align="left" sx={{display:HIDE_XS}}>
                                    <TableData>{row.location}</TableData>
                                </TableCell>
                                <TableCell
                                    align="left"
                                    sx={{
                                        visibility: {
                                            xs: 'hidden',
                                            md: 'visible',
                                        },
                                        display:HIDE_XS
                                    }}
                                >
                                    <TableData>{row.company}</TableData>
                                </TableCell>
                                <TableCell align="left">
                                <Button onClick={()=>onUserSelected(row)}
                                        sx={{minWidth:'100px'}}
                                        variant="contained" color={
                                            (row.measurements && row.measurements.length>0 && row.status !== 'รอการตรวจ')? (row.status==="ปกติ" ? "success" : (row.status==='เฝ้าระวัง'?"warning":"error")):"primary"
                                        }
                                       >{(row.measurements && row.measurements.length>0 && row.status !== 'รอการตรวจ')?(row.status==='ตรวจพบ'?'ไม่ผ่าน':row.status):"รอการตรวจ"}
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                    {emptyRows > 0 && (
                        <TableRow
                            style={{
                                height: 53 * emptyRows,
                            }}
                        >
                            <TableCell colSpan={6} />
                        </TableRow>
                    )}
                </TableBody>
            </StyledTable>

            <TablePagination
                sx={{ px: 2 }}
                rowsPerPageOptions={[5, 10, 20, 30]}
                component="div"
                count={total}
                rowsPerPage={pageSize}
                page={currentPage}
                backIconButtonProps={{
                    'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                    'aria-label': 'Next Page',
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    )
}

export default AttendanceTable
